export default {
    owner: ['newMessage', 'disband'],
    manager: ['clubChips', 'newMessage', 'disband'],
    agent: ["grandCredit"]
}


//agent: ["grandCredit", "quit"]
